"use strict";

exports.__esModule = true;
var _ReportElement = require("./ReportElement");
Object.keys(_ReportElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportElement[key]) return;
  exports[key] = _ReportElement[key];
});
var _ReportFields = require("./ReportFields");
Object.keys(_ReportFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportFields[key]) return;
  exports[key] = _ReportFields[key];
});
var _EditableReportElement = require("./EditableReportElement");
Object.keys(_EditableReportElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditableReportElement[key]) return;
  exports[key] = _EditableReportElement[key];
});
var _ReportWidgetThumbnail = require("./ReportWidgetThumbnail");
Object.keys(_ReportWidgetThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportWidgetThumbnail[key]) return;
  exports[key] = _ReportWidgetThumbnail[key];
});
var _ReportHeader = require("./ReportHeader");
Object.keys(_ReportHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportHeader[key]) return;
  exports[key] = _ReportHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});